import Lookup from 'src/componentes/select-async';
import AuditoriaList from 'src/paginas/gestao-risco/auditoria/AuditoriaRiscoList';

const getAuditoriaRiscoOptionValue = (option) =>
  `${option?.isPlanoAuditoria ? 'plano' : 'auditoria'}-${option?.id}`;

const AuditoriaRiscoLookup = ({ data, ...rest }) => {
  return (
    <Lookup
      labelKey="nome"
      valueKey="id"
      getOptionValue={getAuditoriaRiscoOptionValue}
      getItemKey={getAuditoriaRiscoOptionValue}
      data={{ ...data, incluirPlanoAuditoria: true }}
      showSearch={true}
      showNew={false}
      url="/AuditoriaRiscoLookup"
      clearable
      searchComponent={AuditoriaList}
      {...rest}
    />
  );
};

export default AuditoriaRiscoLookup;